<div class="strength">
  <div
    class="strength__bar"
    role="progressbar"
    aria-label="Força da senha"
    aria-valuemin="0"
    aria-valuemax="100"
    [attr.aria-valuenow]="percent"
    [attr.aria-valuetext]="levelLabel || 'Sem senha'">
    <div class="strength__fill" [ngClass]="'strength__fill--' + level" [style.width.%]="percent"></div>
  </div>
  <span class="strength__label" [ngClass]="'strength__label--' + level" aria-live="polite">{{ levelLabel }}</span>
</div>

<ul class="password-rules" aria-live="polite" aria-label="Requisitos da nova senha">
  <li *ngFor="let rule of rules" [class.is-met]="isMet(rule.test)" [class.is-unmet]="isUnmet(rule.test)">
    <mat-icon aria-hidden="true">{{ icon(rule.test) }}</mat-icon>
    <span>{{ rule.label }}</span>
    <span class="sr-only">{{ isMet(rule.test) ? '(atendido)' : '(pendente)' }}</span>
  </li>
</ul>
